/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleSetRulesInner
 */
export interface GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleSetRulesInner {
    /**
     * 
     * @type {string}
     * @memberof GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleSetRulesInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleSetRulesInner
     */
    'code': string;
    /**
     * 
     * @type {number}
     * @memberof GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleSetRulesInner
     */
    'rate': number;
    /**
     * 
     * @type {string}
     * @memberof GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleSetRulesInner
     */
    'merchantCategoryCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleSetRulesInner
     */
    'merchantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleSetRulesInner
     */
    'binSponsor'?: GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleSetRulesInnerBinSponsorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleSetRulesInner
     */
    'creditOrPrepaid'?: GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleSetRulesInnerCreditOrPrepaidEnum;
    /**
     * 
     * @type {number}
     * @memberof GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleSetRulesInner
     */
    'minimumTotalAmount': number;
}

export const GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleSetRulesInnerBinSponsorEnum = {
    lc: 'LC',
    cs: 'CS'
} as const;

export type GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleSetRulesInnerBinSponsorEnum = typeof GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleSetRulesInnerBinSponsorEnum[keyof typeof GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleSetRulesInnerBinSponsorEnum];
export const GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleSetRulesInnerCreditOrPrepaidEnum = {
    credit: 'CREDIT',
    prepaid: 'PREPAID'
} as const;

export type GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleSetRulesInnerCreditOrPrepaidEnum = typeof GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleSetRulesInnerCreditOrPrepaidEnum[keyof typeof GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleSetRulesInnerCreditOrPrepaidEnum];


